export default __webpack_public_path__ + "static/media/logo-big.c78aca84.jpg";